import type { AuthUser } from '@/types'

/**
 * Get the appropriate redirect path based on user role
 */
export function getRedirectPath(user: AuthUser | null): string {
  if (!user) return '/login'

  switch (user.role) {
    case 'super_admin':
      return '/admin/dashboard'
    case 'organization_admin':
      return '/organization/analytics'
    case 'counselor':
      return '/organization/analytics'
    default:
      // couple or other roles
      return '/dashboard'
  }
}

/**
 * Check if a path is allowed for a given user role
 * This prevents couples from being redirected to admin/organization routes
 */
export function isPathAllowedForRole(path: string, role: string | undefined): boolean {
  if (!path || !role) return false

  // Admin routes - only for super_admin
  if (path.startsWith('/admin')) {
    return role === 'super_admin'
  }

  // Organization routes - for organization_admin and counselor
  if (path.startsWith('/organization')) {
    return role === 'super_admin' || role === 'organization_admin' || role === 'counselor'
  }

  // Couple routes (dashboard, assessment, results, learning-path, settings)
  // These are accessible to all authenticated users
  return true
}
